export default __webpack_public_path__ + "static/media/DownloadIcon.97e5b78f.svg";